import { withProfiler } from '@sentry/react';
import { AppApiClientProvider } from 'app/api/app-api/AppApiClientContext';
import CookieBar from "../cookies/CookieBar";
import { LegolandApp, useMeQuery } from 'legoland-sdk/dist/experimental';
import { forwardRef, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import ReactModal from 'react-modal';
import { Link, Router, useRouteMatch } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { tombac } from 'tombac';
import messages from "../../i18n/messages/en-GB.json";
import "./App.css";
import { AppConfigProvider } from "./AppConfigContext";
import { AppNavbar } from "./AppNavbar";
import { AppRoutes } from "./AppRoutes";
import { appInsights, browserHistory } from "./track";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
ReactModal.setAppElement('#app');
const AppInsights = () => {
  const {
    data
  } = useMeQuery();
  const email = data?.me?.email;
  useEffect(() => {
    if (email) {
      appInsights.setAuthenticatedUserContext(email);
    }
  }, [email]);
  return null;
};
const GlobalStyle = createGlobalStyle(["body{font-family:", ";}#app{display:flex;flex-direction:column;min-height:100vh;}"], tombac.altFontFamily);
function forwardLink({
  href,
  ...rest
}, ref) {
  return /*#__PURE__*/_jsx(Link, {
    to: href,
    ...rest,
    ref: ref,
    "data-sentry-element": "Link",
    "data-sentry-component": "forwardLink",
    "data-sentry-source-file": "App.tsx"
  });
}
forwardLink.displayName = 'AppLink';
const AppLink = /*#__PURE__*/forwardRef(forwardLink);
const ConfiguredApp = ({
  children
}) => {
  const logoutPageMatch = useRouteMatch('/logout');
  return /*#__PURE__*/_jsx(LegolandApp, {
    autoRefreshToken: !logoutPageMatch,
    internalLinkComponent: AppLink,
    environment: process.env.APP_ENV === 'prod' ? 'production' : process.env.APP_ENV === 'test' ? 'test' : 'development',
    legolandUiUrl: "",
    newReleaseNotifications: true,
    releaseNotesUrl: "/release-notes",
    toastsProviderProps: {
      topOffset: 'navbar',
      zIndex: 20000
    },
    "data-sentry-element": "LegolandApp",
    "data-sentry-component": "ConfiguredApp",
    "data-sentry-source-file": "App.tsx",
    children: children
  });
};
const App = () => /*#__PURE__*/_jsx(Router, {
  history: browserHistory,
  "data-sentry-element": "Router",
  "data-sentry-component": "App",
  "data-sentry-source-file": "App.tsx",
  children: /*#__PURE__*/_jsx(IntlProvider, {
    messages: messages,
    locale: "en-GB",
    "data-sentry-element": "IntlProvider",
    "data-sentry-source-file": "App.tsx",
    "data-sentry-element": "IntlProvider",
    children: /*#__PURE__*/_jsx(AppConfigProvider, {
      "data-sentry-element": "AppConfigProvider",
      "data-sentry-source-file": "App.tsx",
      "data-sentry-element": "AppConfigProvider",
      children: /*#__PURE__*/_jsx(ConfiguredApp, {
        "data-sentry-element": "ConfiguredApp",
        "data-sentry-source-file": "App.tsx",
        "data-sentry-element": "ConfiguredApp",
        children: /*#__PURE__*/_jsxs(AppApiClientProvider, {
          "data-sentry-element": "AppApiClientProvider",
          "data-sentry-source-file": "App.tsx",
          "data-sentry-element": "AppApiClientProvider",
          children: [/*#__PURE__*/_jsx(AppInsights, {
            "data-sentry-element": "AppInsights",
            "data-sentry-source-file": "App.tsx",
            "data-sentry-element": "AppInsights"
          }), /*#__PURE__*/_jsx(GlobalStyle, {
            "data-sentry-element": "GlobalStyle",
            "data-sentry-source-file": "App.tsx",
            "data-sentry-element": "GlobalStyle"
          }), /*#__PURE__*/_jsx(AppNavbar, {
            "data-sentry-element": "AppNavbar",
            "data-sentry-source-file": "App.tsx",
            "data-sentry-element": "AppNavbar"
          }), /*#__PURE__*/_jsx(AppRoutes, {
            "data-sentry-element": "AppRoutes",
            "data-sentry-source-file": "App.tsx",
            "data-sentry-element": "AppRoutes"
          }), /*#__PURE__*/_jsx(CookieBar, {
            "data-sentry-element": "CookieBar",
            "data-sentry-source-file": "App.tsx",
            "data-sentry-element": "CookieBar"
          })]
        })
      })
    })
  })
});

// withProfile does not seem to work or I don't know how to use it properly. However, I will leave it here for now. Maybe we will discover its purpose this way by chance.
const ProfiledApp = withProfiler(App);
export { ProfiledApp as App };